import { useState } from "react";
import { useLang } from "../../../core/lang";
import LangKeys from "../../../core/locales/keys";

function StaffCountPage({ setActivePage }) {
  const { t } = useLang();

  const cached = JSON.parse(localStorage.getItem("business_profile") || "null");
  const [selected, setSelected] = useState(Number(cached?.staff_count || 0));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    try {
      setSaving(true);

      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://khata.moxpal.com/api/v2/index.php/business-profile/staff",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            staff_count: selected,
          }),
        }
      );

      const data = await res.json();

      if (!data?.success) {
        throw new Error(data?.error?.message || t(LangKeys.failed_to_save));
      }

      const updated = {
        ...(cached || {}),
        staff_count: selected,
      };

      localStorage.setItem("business_profile", JSON.stringify(updated));
      setActivePage(null);
    } catch (err) {
      alert(err.message || t(LangKeys.failed_to_save));
    } finally {
      setSaving(false);
    }
  };

  const items = [0, 1, 2, 3, 4, 5];

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => setActivePage(null)}>
          ←
        </button>
        <h2 style={styles.title}>{t(LangKeys.staff_details)}</h2>
      </div>

      <div style={styles.card}>
        <div style={styles.label}>{t(LangKeys.staff_question)}</div>

        <div style={styles.grid}>
          {items.map((v) => {
            const isActive = selected === v;
            const label = v === 5 ? "5+" : `${v}`;

            return (
              <button
                key={v}
                onClick={() => setSelected(v)}
                style={{
                  ...styles.gridItem,
                  ...(isActive ? styles.gridItemActive : {}),
                }}
              >
                {label}
              </button>
            );
          })}
        </div>

        <button
          style={{
            ...styles.saveBtn,
            ...(saving ? styles.saveBtnDisabled : {}),
          }}
          onClick={save}
          disabled={saving}
        >
          {saving ? t(LangKeys.saving) : t(LangKeys.confirm)}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    padding: "16px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },

  backBtn: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    background: "#fff",
    cursor: "pointer",
    fontSize: "20px",
  },

  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
  },

  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "24px",
    border: "1px solid #E5E7EB",
    maxWidth: "620px",
  },

  label: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#111827",
    marginBottom: "16px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: "10px",
    marginBottom: "18px",
  },

  gridItem: {
    height: "52px",
    borderRadius: "12px",
    border: "1px solid #D1D5DB",
    background: "#fff",
    fontSize: "15px",
    fontWeight: "600",
    color: "#111827",
    cursor: "pointer",
  },

  gridItemActive: {
    background: "#2563EB",
    color: "#fff",
    border: "1px solid #2563EB",
  },

  saveBtn: {
    width: "100%",
    height: "48px",
    border: "none",
    borderRadius: "14px",
    background: "#2563EB",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
  },

  saveBtnDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
};

export default StaffCountPage;